import { Link } from '@/components/Link/Link';
import { type ArticleDefectWithRelations, useRequests } from '@/models/request';

export const LinkedOriginalRequestReference = ({
  originalRequest,
}: {
  originalRequest: NonNullable<
    ArticleDefectWithRelations['exceptionalBrandResponsibilityCoverageOriginalRequest']
  >;
}) => {
  const { data, isSuccess } = useRequests(
    {
      reference: originalRequest.reference,
    },
    {
      enabled: !!originalRequest.reference,
    }
  );

  const hasAccess =
    isSuccess && !!data?.requests.some((request) => request.id === originalRequest.id);

  if (!hasAccess) {
    return `${originalRequest.reference}`;
  }

  return (
    <Link
      to={`/requests/${originalRequest.id}`}
      className="text-link"
      style={{ textDecoration: 'underline' }}
    >
      {originalRequest.reference}
    </Link>
  );
};
